import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { InstanciasService } from 'src/app/app.service';

/**
 * Restringe as telas de Documentação da Expedição Contínua ao grupo Admin.
 *
 * Os itens de menu já são criados apenas em menuAlter(), mas menu oculto não é
 * controle de acesso: sem este guard, um usuário autenticado fora do grupo Admin
 * alcançaria a tela digitando a URL. O endpoint também valida o perfil
 * (getSessionAdminByToken -> HTTP 403), então a proteção é em duas camadas.
 *
 * Usado em conjunto com o Authguard, que trata a ausência de sessão.
 */
export const expDocAdminGuard: CanActivateFn = (): boolean | UrlTree => {
    const instservice = inject(InstanciasService);
    const router = inject(Router);

    if (instservice.isGroupAdmin()) {
        return true;
    }

    return router.parseUrl('/');
};
